import api from './api';

export interface Permission {
  id: number;
  name: string;
  slug: string;
  description?: string | null;
}

export interface UserProfile {
  id: number;
  name: string;
  email: string;
  phone?: string;
  birth_date?: string;
  telegram_id?: string;
  avatar?: string;
  position?: string;
  practice?: string;
  manager?: string;
  is_system_admin?: boolean;
  is_user_manager?: boolean;
  /** Совпадает с логикой списка пользователей дашборда (активность токена за 10 мин) */
  is_online?: boolean;
  position_id?: number | null;
  position_data?: {
    id: number;
    name: string;
    slug: string;
    description?: string | null;
  } | null;
  permissions?: Record<string, Permission[]>;
}

export interface UserStatistics {
  cases: number;
  /** Активные проекты, где пользователь руководитель / исполнитель / наблюдатель (с учётом видимости для текущего зрителя) */
  projects_participation: number;
  tasks_in_progress: number;
  high_priority_tasks: number;
  overdue_tasks: number;
}

export interface UpdateProfileData {
  name?: string;
  email?: string;
  phone?: string;
  birth_date?: string;
  telegram_id?: string;
  avatar?: File;
  current_password?: string;
  new_password?: string;
  new_password_confirmation?: string;
}

export const userService = {
  /**
   * Получить профиль текущего пользователя
   */
  async getProfile(): Promise<UserProfile> {
    const { data } = await api.get<UserProfile>('/profile');
    return data;
  },

  /**
   * Обновить профиль пользователя
   */
  async updateProfile(profileData: UpdateProfileData): Promise<UserProfile> {
    // Проверяем, есть ли файл аватара
    const hasAvatar = profileData.avatar && profileData.avatar instanceof File;
    
    if (hasAvatar) {
      // Если есть файл, используем FormData
      const formData = new FormData();
      
      Object.keys(profileData).forEach(key => {
        const value = profileData[key as keyof UpdateProfileData];
        if (value !== undefined && value !== null) {
          if (key === 'avatar' && value instanceof File) {
            formData.append('avatar', value);
          } else if (typeof value === 'string' || typeof value === 'number') {
            formData.append(key, String(value));
          }
        }
      });
      
      // НЕ устанавливаем Content-Type вручную - браузер сделает это сам с правильным boundary
      // Используем POST с _method=PUT для правильной обработки файлов
      formData.append('_method', 'PUT');
      
      const { data } = await api.post<{ user: UserProfile }>('/profile', formData);
      return data.user;
    } else {
      // Если нет файла, отправляем обычный JSON
      const { data } = await api.put<{ user: UserProfile }>('/profile', profileData);
      return data.user;
    }
  },

  /**
   * Получить статистику пользователя
   */
  async getStatistics(params?: { for_user_id?: number }): Promise<UserStatistics> {
    const sp = new URLSearchParams();
    if (params?.for_user_id != null) {
      sp.append('for_user_id', String(params.for_user_id));
    }
    const q = sp.toString();
    const { data } = await api.get<UserStatistics>(q ? `/profile/statistics?${q}` : '/profile/statistics');
    return data;
  },
};
